import React from 'react';
import { Table, Button } from 'react-bootstrap';
import axios, { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import './CustomTable.scss';
import moment from 'moment';
import PaymentButton from './PaymentButton';

/**
 * Displays data in table format based on predefined fields (for both Vignette and Violation check)
 *
 * @component - CustomTable
 * @parentComponent - CheckResult
 */

interface RowProps {
  data: Row;
  fields: Fields;
  getCountryByCode?: any;
  t?: any;
}

interface Fields {
  [key: string]: boolean;
}

interface Row {
  [key: string]: string;
}

const customRenderRow = (data: { [key: string]: string }, prop: string, getCountryByCode: any, t: any) => {
  if (!data) return;

  const checkForStatus = (delictId: any) => {
    return axios.get(`/payment/status/${delictId}`)
      .then((result: AxiosResponse<any>) => result.data.status)
      .catch((error: any) => {
        return 0;
      });
  }


  console.log(data.documentStatus);
  const queryString = window.location.href.split("?")[1];
  
  let documentStatusStyle = 'not-paid';
  let documentStatus = t('Violation.status.legislated');

  if (data.documentStatus === 'open') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.open');
  }

  if (data.documentStatus === 'ef_created') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.ef_created');
  }

  if (data.documentStatus === 'np_creared') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.np_creared');
  }

  if (data.documentStatus === 'ef_legislated') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.ef_legislated');
  }

  if (data.documentStatus === 'paid') {
    documentStatusStyle = 'paid';
    documentStatus = t('Violation.status.v2.paid');
  }

  if (data.documentStatus === 'ef_partially_paid_KT') {
    documentStatusStyle = 'paid';
    documentStatus = t('Violation.status.v2.ef_partially_paid_KT');
  }

  if (data.documentStatus === 'rp_28') {
    documentStatusStyle = 'paid';
    documentStatus = t('Violation.status.v2.rp_28');
  }

  if (data.documentStatus === 'ef_partially_paid') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.ef_partially_paid');
  }

  if (data.documentStatus === 'auan_received') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.auan_received');
  }

  if (data.documentStatus === 'auan_for_proceeding') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.auan_for_proceeding');
  }

  if (data.documentStatus === 'max_promo') {
    documentStatusStyle = 'received';
    documentStatus = t('Violation.status.v2.max_promo');
  }

  if (data.documentStatus === 'paid_max_promo') {
    documentStatusStyle = 'paid';
    documentStatus = t('Violation.status.v2.paid_max_promo');
  }
  
  switch (prop) {
    case 'showPayment':
      //if (queryString === "enablePayment" || queryString === "enablePayment=true") {
         
          if (!data.displayPaymentButton) {
            return "";
          }

          if (data.orderId === null && data.responseCode != "00") {
            return <PaymentButton key={data.delictId} t={t} checkForStatus={checkForStatus} delictId={data.delictId} />    
          }
  
          if (data.orderId !== null && data.responseCode === null ) {
            return <span className={'cell--status paid waiting'}>{t('waiting.payment.confirmation')}</span>
          }
  
          if ((data.orderId !== null && data.responseCode !== null) && data.responseCode !== '00') {
            return <PaymentButton key={data.delictId} t={t} checkForStatus={checkForStatus} delictId={data.delictId} />
          }

        return "";
      /*} else {
        return "";
      }*/
    case 'country':
      return <span className="cell--country">{getCountryByCode(data[prop])}</span>;
    case 'price':
      return (
        <span className="cell--amount">
          {data.price || 0.0} {t('Table.td.leva')}
        </span>
      );
    case 'amount':
      if (!data.displayPaymentButton) {
        return "-";
      } else {
        return (
          <span className="cell--amount">
            {data.amount || 0.0} {t('Table.td.leva')}
          </span>
        );
      }
    case 'paid':
      return (
        <span className={`cell--status ${data.paid ? 'paid' : 'not-paid'}`}>
          {data.paid ? t('Table.td.paid') : t('Table.td.notPaid')}
        </span>
      );
    case 'documentStatus':
      return (
        <span className={`cell--status ${documentStatusStyle}`}>
          {data.documentStatus != null ? documentStatus : ''}
        </span>
      );
    case 'status':
      return (
        <span className={`cell--status ${data.status === 'Активна' ? 'paid' : 'not-paid'}`}> {t(data.status)} </span>
      );
    case 'emissionsClass':
      return t(data.emissionsClass);
    case 'vehicleClass':
      return t(data.vehicleClass);
    case 'delictDate':
      return data.delictDate !== null ? moment(data.delictDate).format('DD.MM.YYYY HH:mm') : '';
     case 'documentNumber':
        return <span className="cell--country">{data.documentNumber}</span>;  
    default:
      return data[prop];
  }
};

const Row = ({ data, fields, getCountryByCode, t }: RowProps) => {
  return (
    <tr>
      {Object.keys(fields).map((prop: string) => {
        return <td key={prop}>{customRenderRow(data, prop, getCountryByCode, t)}</td>;
      })}
    </tr>
  )
};

const Header = (props: any) => (
  <thead>
    <tr>
      {props.header.map((title: string) => (
        <th key={title}>{title.replace(/\u00A0/g, ' ')}</th>
      ))}
    </tr>
  </thead>
);

export const CustomTablev2 = (props: any) => {
  const { t } = useTranslation();
  return (
    <Table responsive className="CustomTable">
      <Header header={props.header} />
      <tbody>
        {props.data.map((data: any, index: number) => (
          <Row key={index} data={data} fields={props.fields} getCountryByCode={props.getCountryByCode} t={t}/>
        ))}
      </tbody>
    </Table>
  );
};
